// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Logger = require("./Logger.bs.js");
var Biwriter = require("./Biwriter.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Ior = require("relude/src/Relude_Ior.bs.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Tuple = require("relude/src/Relude_Tuple.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Array$BsBastet = require("bs-bastet/bastet/src/Array.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Extensions_Alt = require("relude/src/extensions/Relude_Extensions_Alt.bs.js");
var Relude_List_Instances = require("relude/src/list/Relude_List_Instances.bs.js");
var Relude_Extensions_Apply = require("relude/src/extensions/Relude_Extensions_Apply.bs.js");
var Relude_Extensions_Monad = require("relude/src/extensions/Relude_Extensions_Monad.bs.js");
var Relude_Extensions_Functor = require("relude/src/extensions/Relude_Extensions_Functor.bs.js");
var Relude_Extensions_Bifunctor = require("relude/src/extensions/Relude_Extensions_Bifunctor.bs.js");
var Relude_Extensions_Semialign = require("relude/src/extensions/Relude_Extensions_Semialign.bs.js");
var Relude_Extensions_MonadError = require("relude/src/extensions/Relude_Extensions_MonadError.bs.js");
var Relude_Extensions_MonadThrow = require("relude/src/extensions/Relude_Extensions_MonadThrow.bs.js");
var Relude_Extensions_Applicative = require("relude/src/extensions/Relude_Extensions_Applicative.bs.js");

function prependLogEntry(nextContext, prefix, endTimestamp, startTimestamp, data, param) {
  var context = param.context;
  return {
          context: Relude_Option.fold(context, (function (param) {
                  return Relude_Globals.$great$great(Relude_List.reverse, (function (__x) {
                                return Relude_List.concat(__x, context);
                              }), param);
                }), nextContext),
          entries: {
            hd: {
              data: data,
              endTimestamp: endTimestamp,
              prefix: prefix,
              startTimestamp: startTimestamp
            },
            tl: param.entries
          }
        };
}

function apply_right(ioABToC, ioAB) {
  return Relude_IO.catchError((function (bToC) {
                return Curry._2(Relude_IO.mapError, bToC, ioAB);
              }), ioABToC);
}

var partial_arg = {
  bimap: Relude_IO.bimap,
  map_left: Relude_IO.map,
  map_right: Relude_IO.mapError,
  apply_left: Relude_IO.apply,
  apply_right: apply_right,
  pure_left: Relude_IO.pure,
  pure_right: Relude_IO.$$throw,
  flat_map_left: Relude_IO.flatMap,
  flat_map_right: Relude_IO.catchError
};

var param = {
  Monoid: {
    append: Logger.Monoid.append,
    empty: Logger.Monoid.empty
  }
};

var include = Biwriter.BiwriterT.WithBimonadAndLog(partial_arg, param);

var Biwriter$1 = include.Biwriter;

var Log = include.Log;

var fromBimonad = include.fromBimonad;

var runWriterT = include.runWriterT;

var Bifunctor = include.Bifunctor;

var bimap = include.bimap;

var bimapWithAppendLog = include.bimapWithAppendLog;

var mapLeft = include.mapLeft;

var mapLeftWithAppendLog = include.mapLeftWithAppendLog;

var mapRight = include.mapRight;

var mapRightWithAppendLog = include.mapRightWithAppendLog;

var map = include.map;

var mapWithAppendLog = include.mapWithAppendLog;

var apply = include.apply;

var pureRight = include.pureRight;

var pure = include.pure;

var flatMapRight = include.flatMapRight;

var flatMap = include.flatMap;

function toIO(io) {
  return Relude_IO.bimap((function (prim) {
                return prim[0];
              }), (function (prim) {
                return prim[0];
              }), Curry._1(runWriterT, io));
}

function tap(f, io) {
  return Curry._2(map, (function (a) {
                Curry._1(f, a);
                return a;
              }), io);
}

function tapError(f, io) {
  return Curry._2(mapRight, (function (e) {
                Curry._1(f, e);
                return e;
              }), io);
}

function bitap(fa, fe, io) {
  return tapError(fe, tap(fa, io));
}

function suspend(thunk) {
  return Curry._2(map, thunk, Curry._1(pure, undefined));
}

function suspendIO(thunk) {
  return Curry._2(flatMap, thunk, Curry._1(pure, undefined));
}

function summonError(a) {
  return /* BiwriterT */{
          _0: Curry._2(Relude_IO.mapError, (function (__x) {
                  return Relude_Tuple.make(__x, Logger.Monoid.empty);
                }), Relude_IO.map((function (param) {
                      return Relude_Result.fold((function (param) {
                                    return [
                                            {
                                              TAG: /* Error */1,
                                              _0: param[0]
                                            },
                                            param[1]
                                          ];
                                  }), (function (param) {
                                    return [
                                            {
                                              TAG: /* Ok */0,
                                              _0: param[0]
                                            },
                                            param[1]
                                          ];
                                  }), param);
                    }), Relude_IO.summonError(a._0)))
        };
}

function unsummonError(a) {
  return /* BiwriterT */{
          _0: Relude_IO.unsummonError(Relude_IO.map((function (param) {
                      var e = param[0];
                      if (e.TAG === /* Ok */0) {
                        return {
                                TAG: /* Ok */0,
                                _0: [
                                  e._0,
                                  param[1]
                                ]
                              };
                      } else {
                        return {
                                TAG: /* Error */1,
                                _0: [
                                  e._0,
                                  param[1]
                                ]
                              };
                      }
                    }), Curry._2(Relude_IO.mapError, (function (prim) {
                          return prim[0];
                        }), a._0)))
        };
}

function biflatMap(handleResult, handleError, io) {
  return unsummonError(Curry._2(flatMap, (function (param) {
                    return Relude_Globals.$great$great((function (param) {
                                  return Relude_Result.fold(handleError, handleResult, param);
                                }), summonError, param);
                  }), summonError(io)));
}

function triesJs(x) {
  return Curry._1(fromBimonad, Relude_IO.triesJS(x));
}

function delay(millis) {
  return Curry._1(fromBimonad, Relude_IO.delay(millis));
}

function withDelayAfter(delay, a) {
  return /* BiwriterT */{
          _0: Relude_IO.withDelayAfter(delay, a._0)
        };
}

function withDelayBefore(delay, a) {
  return /* BiwriterT */{
          _0: Relude_IO.withDelayBefore(delay, a._0)
        };
}

function getTimestamp(param) {
  return suspend(function (param) {
              return new Date();
            });
}

function timeIO(ioAE) {
  return Curry._2(flatMap, (function (startTimestamp) {
                return Curry._2(flatMapRight, (function (e) {
                              return Curry._2(flatMap, (function (endTimestamp) {
                                            return Curry._1(pureRight, [
                                                        e,
                                                        startTimestamp,
                                                        endTimestamp
                                                      ]);
                                          }), suspend(function (param) {
                                              return new Date();
                                            }));
                            }), Curry._2(flatMap, (function (a) {
                                  return Curry._2(map, (function (endTimestamp) {
                                                return [
                                                        a,
                                                        startTimestamp,
                                                        endTimestamp
                                                      ];
                                              }), suspend(function (param) {
                                                  return new Date();
                                                }));
                                }), ioAE));
              }), suspend(function (param) {
                  return new Date();
                }));
}

function addContext(nextContext, ioAE) {
  return Curry._4(bimapWithAppendLog, (function (param) {
                return {
                        context: Relude_List.concat(nextContext, param.context),
                        entries: param.entries
                      };
              }), Relude_Globals.id, Relude_Globals.id, ioAE);
}

function mapWithLog(context, prefix, log, aToB, ioA) {
  return Curry._2(flatMap, (function (param) {
                var endTimestamp = param[2];
                var startTimestamp = param[1];
                var b = param[0];
                var partial_arg = Curry._1(log, b);
                return Curry._3(mapWithAppendLog, (function (param) {
                              return prependLogEntry(context, prefix, endTimestamp, startTimestamp, partial_arg, param);
                            }), Relude_Globals.id, Curry._1(pure, b));
              }), Curry._2(flatMap, (function (a) {
                    return Curry._2(flatMap, (function (startTimestamp) {
                                  return Curry._2(flatMap, (function (b) {
                                                return Curry._2(map, (function (endTimestamp) {
                                                              return [
                                                                      b,
                                                                      startTimestamp,
                                                                      endTimestamp
                                                                    ];
                                                            }), suspend(function (param) {
                                                                return new Date();
                                                              }));
                                              }), Curry._1(pure, Curry._1(aToB, a)));
                                }), suspend(function (param) {
                                    return new Date();
                                  }));
                  }), ioA));
}

function mapWithLogMessage(context, prefix, message, aToB, ioA) {
  var partial_arg = Logger.Data.message(message);
  return mapWithLog(context, prefix, (function (param) {
                return Relude_Globals.$$const(partial_arg, param);
              }), aToB, ioA);
}

function map$1(context, prefix, log, aToB, ioA) {
  return Relude_Option.fold(Curry._2(mapLeft, aToB, ioA), (function (log) {
                return mapWithLog(context, prefix, (function (param) {
                              return Relude_Globals.$great$great(log, Logger.Data.json, param);
                            }), aToB, ioA);
              }), log);
}

function log(context, prefix, logA, ioA) {
  return Curry._2(flatMap, (function (param) {
                var endTimestamp = param[2];
                var startTimestamp = param[1];
                var a = param[0];
                var partial_arg = Curry._1(logA, a);
                return Curry._3(mapWithAppendLog, (function (param) {
                              return prependLogEntry(context, prefix, endTimestamp, startTimestamp, partial_arg, param);
                            }), Relude_Globals.id, Curry._1(pure, a));
              }), Curry._2(mapRight, (function (param) {
                    return param[0];
                  }), timeIO(ioA)));
}

function logMessage(context, prefix, message) {
  var partial_arg = Logger.Data.message(message);
  var partial_arg$1 = function (param) {
    return Relude_Globals.$$const(partial_arg, param);
  };
  return function (param) {
    return log(context, prefix, partial_arg$1, param);
  };
}

function mapErrorWithLog(context, prefix, log, eToF, ioE) {
  return Curry._2(flatMapRight, (function (e) {
                return Curry._2(flatMap, (function (startTimestamp) {
                              return Curry._2(flatMap, (function (f) {
                                            return Curry._2(flatMap, (function (endTimestamp) {
                                                          var partial_arg = Curry._1(log, f);
                                                          return Curry._3(mapRightWithAppendLog, (function (param) {
                                                                        return prependLogEntry(context, prefix, endTimestamp, startTimestamp, partial_arg, param);
                                                                      }), Relude_Globals.id, Curry._1(pureRight, f));
                                                        }), suspend(function (param) {
                                                            return new Date();
                                                          }));
                                          }), Curry._1(pure, Curry._1(eToF, e)));
                            }), suspend(function (param) {
                                return new Date();
                              }));
              }), ioE);
}

function mapErrorWithLogMessage(context, prefix, message, eToF, ioE) {
  var partial_arg = Logger.Data.message(message);
  return mapErrorWithLog(context, prefix, (function (param) {
                return Relude_Globals.$$const(partial_arg, param);
              }), eToF, ioE);
}

function mapErrorWithLogExn(context, prefix, eToF, ioE) {
  return mapErrorWithLog(context, prefix, Logger.Data.exn, eToF, ioE);
}

function mapError(context, prefix, log, eToF, ioE) {
  return Relude_Option.fold(Curry._2(mapRight, eToF, ioE), (function (log) {
                return mapErrorWithLog(context, prefix, (function (param) {
                              return Relude_Globals.$great$great(log, Logger.Data.json, param);
                            }), eToF, ioE);
              }), log);
}

function logError(context, prefix, logE, ioE) {
  return Curry._2(flatMapRight, (function (param) {
                var endTimestamp = param[2];
                var startTimestamp = param[1];
                var e = param[0];
                var partial_arg = Curry._1(logE, e);
                return Curry._3(mapRightWithAppendLog, (function (param) {
                              return prependLogEntry(context, prefix, endTimestamp, startTimestamp, partial_arg, param);
                            }), Relude_Globals.id, Curry._1(pureRight, e));
              }), map$1(undefined, undefined, undefined, (function (param) {
                    return param[0];
                  }), timeIO(ioE)));
}

function logExn(context, prefix) {
  return function (param) {
    return logError(context, prefix, Logger.Data.exn, param);
  };
}

function bimapWithLog(context, prefix, prefixErrorOpt, prefixOkOpt, log, aToB, eToF, ioAE) {
  var prefixError = prefixErrorOpt !== undefined ? prefixErrorOpt : "FAILED";
  var prefixOk = prefixOkOpt !== undefined ? prefixOkOpt : "Succeeded";
  return mapErrorWithLog(context, Relude_Option.map((function (prefix) {
                    return prefix + (" " + (prefixError + " "));
                  }), prefix), (function (param) {
                return Relude_Globals.$great$great(Relude_Result.error, log, param);
              }), eToF, mapWithLog(context, Relude_Option.map((function (prefix) {
                        return prefix + (" " + (prefixOk + " "));
                      }), prefix), (function (param) {
                    return Relude_Globals.$great$great(Relude_Result.pure, log, param);
                  }), aToB, ioAE));
}

function bimapWithLogMessage(context, prefix, prefixError, prefixOk, message, aToB, eToF, ioAE) {
  return bimapWithLog(context, prefix, prefixError, prefixOk, (function (param) {
                return Relude_Globals.$great$great(message, Logger.Data.message, param);
              }), aToB, eToF, ioAE);
}

function bimap$1(context, prefix, prefixError, prefixOk, log, aToB, eToF, ioAE) {
  return Relude_Option.fold(Curry._3(bimap, aToB, eToF, ioAE), (function (log) {
                return bimapWithLog(context, prefix, prefixError, prefixOk, (function (param) {
                              return Relude_Globals.$great$great(log, Logger.Data.json, param);
                            }), aToB, eToF, ioAE);
              }), log);
}

function bilog(context, prefix, prefixErrorOpt, prefixOkOpt, log, ioAE) {
  var prefixError = prefixErrorOpt !== undefined ? prefixErrorOpt : "FAILED";
  var prefixOk = prefixOkOpt !== undefined ? prefixOkOpt : "Succeeded";
  return Curry._2(flatMap, (function (param) {
                var endTimestamp = param[2];
                var startTimestamp = param[1];
                var a = param[0];
                var partial_arg = Curry._1(log, Relude_Result.pure(a));
                var partial_arg$1 = Relude_Option.map((function (prefix) {
                        return prefix + (" " + (prefixOk + " "));
                      }), prefix);
                return Curry._3(mapLeftWithAppendLog, (function (param) {
                              return prependLogEntry(context, partial_arg$1, endTimestamp, startTimestamp, partial_arg, param);
                            }), Relude_Globals.id, Curry._1(pure, a));
              }), Curry._2(flatMapRight, (function (param) {
                    var endTimestamp = param[2];
                    var startTimestamp = param[1];
                    var e = param[0];
                    var partial_arg = Curry._1(log, Relude_Result.error(e));
                    var partial_arg$1 = Relude_Option.map((function (prefix) {
                            return prefix + (" " + (prefixError + " "));
                          }), prefix);
                    return Curry._3(mapRightWithAppendLog, (function (param) {
                                  return prependLogEntry(context, partial_arg$1, endTimestamp, startTimestamp, partial_arg, param);
                                }), Relude_Globals.id, Curry._1(pureRight, e));
                  }), timeIO(ioAE)));
}

function bilogWithMessage(context, prefix, prefixError, prefixOk, message, ioAE) {
  return bilog(context, prefix, prefixError, prefixOk, (function (param) {
                return Relude_Globals.$great$great(message, Logger.Data.message, param);
              }), ioAE);
}

function flatMapWithLog(context, prefix, log, aToIOB, ioA) {
  return Curry._2(flatMap, (function (a) {
                return Curry._2(flatMap, (function (startTimestamp) {
                              return Curry._2(flatMap, (function (b) {
                                            return Curry._2(flatMap, (function (endTimestamp) {
                                                          var partial_arg = Curry._1(log, b);
                                                          return Curry._3(mapLeftWithAppendLog, (function (param) {
                                                                        return prependLogEntry(context, prefix, endTimestamp, startTimestamp, partial_arg, param);
                                                                      }), Relude_Globals.id, Curry._1(pure, b));
                                                        }), suspend(function (param) {
                                                            return new Date();
                                                          }));
                                          }), Curry._1(aToIOB, a));
                            }), suspend(function (param) {
                                return new Date();
                              }));
              }), ioA);
}

function flatMapWithLogMessage(context, prefix, message, aToIOB, ioA) {
  var partial_arg = Logger.Data.message(message);
  return flatMapWithLog(context, prefix, (function (param) {
                return Relude_Globals.$$const(partial_arg, param);
              }), aToIOB, ioA);
}

function flatMap$1(context, prefix, log, aToIOB, ioA) {
  return Relude_Option.fold(Curry._2(flatMap, aToIOB, ioA), (function (log) {
                return flatMapWithLog(context, prefix, (function (param) {
                              return Relude_Globals.$great$great(log, Logger.Data.json, param);
                            }), aToIOB, ioA);
              }), log);
}

function bind(ioA, context, prefix, log, aToIOB) {
  return flatMap$1(context, prefix, log, aToIOB, ioA);
}

function catchErrorWithLog(context, prefix, log, eToIOAF, ioAE) {
  return Curry._2(flatMapRight, (function (e) {
                return flatMap$1(undefined, undefined, undefined, (function (startTimestamp) {
                              return Curry._2(flatMapRight, (function (f) {
                                            return flatMap$1(undefined, undefined, undefined, (function (endTimestamp) {
                                                          var partial_arg = Curry._1(log, f);
                                                          return Curry._3(mapRightWithAppendLog, (function (param) {
                                                                        return prependLogEntry(context, prefix, endTimestamp, startTimestamp, partial_arg, param);
                                                                      }), Relude_Globals.id, Curry._1(pureRight, f));
                                                        }), suspend(function (param) {
                                                            return new Date();
                                                          }));
                                          }), Curry._1(eToIOAF, e));
                            }), suspend(function (param) {
                                return new Date();
                              }));
              }), ioAE);
}

function catchErrorWithLogMessage(context, prefix, message, eToIOAF, ioAE) {
  var partial_arg = Logger.Data.message(message);
  return catchErrorWithLog(context, prefix, (function (param) {
                return Relude_Globals.$$const(partial_arg, param);
              }), eToIOAF, ioAE);
}

function catchErrorWithLogExn(context, prefix, eToIOAExn, ioAE) {
  return catchErrorWithLog(context, prefix, Logger.Data.exn, eToIOAExn, ioAE);
}

function catchError(context, prefix, log, eToIOAF, ioAE) {
  return Relude_Option.fold(Curry._2(flatMapRight, eToIOAF, ioAE), (function (log) {
                return catchErrorWithLog(context, prefix, (function (param) {
                              return Relude_Globals.$great$great(log, Logger.Data.json, param);
                            }), eToIOAF, ioAE);
              }), log);
}

function alt(io1, io2) {
  return catchError(undefined, undefined, undefined, (function (param) {
                return io2;
              }), io1);
}

function align(ioA, ioB) {
  return Curry._1(Biwriter$1.make, Relude_IO.map((function (param) {
                    return Relude_Ior.fold((function (param) {
                                  return [
                                          Relude_Ior.$$this(param[0]),
                                          param[1]
                                        ];
                                }), (function (param) {
                                  return [
                                          Relude_Ior.that(param[0]),
                                          param[1]
                                        ];
                                }), (function (param, param$1) {
                                  return [
                                          Relude_Ior.both(param[0], param$1[0]),
                                          Curry._2(Log.Monoid.append, param[1], param$1[1])
                                        ];
                                }), param);
                  }), Relude_IO.align(ioA._0, ioB._0)));
}

function alignWith(f, fa, fb) {
  return map$1(undefined, undefined, undefined, f, align(fa, fb));
}

function WithError(E) {
  var map$2 = function (aToB, ioA) {
    return map$1(undefined, undefined, undefined, aToB, ioA);
  };
  var Functor = {
    map: map$2
  };
  var include = Relude_Extensions_Functor.FunctorExtensions(Functor);
  var Alt = {
    map: map$2,
    alt: alt
  };
  var include$1 = Relude_Extensions_Alt.AltExtensions(Alt);
  var Apply = {
    map: map$2,
    apply: apply
  };
  var include$2 = Relude_Extensions_Apply.ApplyExtensions(Apply);
  var Applicative = {
    map: map$2,
    apply: apply,
    pure: pure
  };
  var include$3 = Relude_Extensions_Applicative.ApplicativeExtensions(Applicative);
  var Semialign = {
    map: map$2,
    align: align,
    alignWith: alignWith
  };
  Relude_Extensions_Semialign.SemialignExtensions(Semialign);
  var flat_map = function (ioAE, aToIOBE) {
    return flatMap$1(undefined, undefined, undefined, aToIOBE, ioAE);
  };
  var Monad = {
    map: map$2,
    apply: apply,
    pure: pure,
    flat_map: flat_map
  };
  var include$4 = Relude_Extensions_Monad.MonadExtensions(Monad);
  var MonadThrow = {
    map: map$2,
    apply: apply,
    pure: pure,
    flat_map: flat_map,
    throwError: pureRight
  };
  Relude_Extensions_MonadThrow.MonadThrowExtensions(MonadThrow);
  var catchError$1 = function (eToIOAF, ioAE) {
    return catchError(undefined, undefined, undefined, eToIOAF, ioAE);
  };
  var MonadError = {
    map: map$2,
    apply: apply,
    pure: pure,
    flat_map: flat_map,
    throwError: pureRight,
    catchError: catchError$1
  };
  Relude_Extensions_MonadError.MonadErrorExtensions(MonadError);
  var include$5 = Relude_Extensions_Functor.FunctorInfix(Functor);
  var $less$$great = include$5.$less$$great;
  var include$6 = Relude_Extensions_Bifunctor.BifunctorInfix(Bifunctor);
  var include$7 = Relude_Extensions_Apply.ApplyInfix(Apply);
  var $less$star$great = include$7.$less$star$great;
  var include$8 = Relude_Extensions_Monad.MonadInfix(Monad);
  var include$9 = Relude_Extensions_Alt.AltInfix(Alt);
  var Infix_FunctorExtensions = include$5.FunctorExtensions;
  var Infix_$less$hash$great = include$5.$less$hash$great;
  var Infix_$less$dollar = include$5.$less$;
  var Infix_$$great = include$5.$$great;
  var Infix_$less$at$great = include$5.$less$at$great;
  var Infix_$less$less$dollar$great$great = include$6.$less$less$$great$great;
  var Infix_ApplyExtensions = include$7.ApplyExtensions;
  var Infix_$less$star = include$7.$less$star;
  var Infix_$star$great = include$7.$star$great;
  var Infix_MonadExtensions = include$8.MonadExtensions;
  var Infix_$great$great$eq = include$8.$great$great$eq;
  var Infix_$eq$less$less = include$8.$eq$less$less;
  var Infix_$great$eq$great = include$8.$great$eq$great;
  var Infix_$less$eq$less = include$8.$less$eq$less;
  var Infix_$less$pipe$great = include$9.$less$pipe$great;
  var Infix = {
    FunctorExtensions: Infix_FunctorExtensions,
    $less$$great: $less$$great,
    $less$hash$great: Infix_$less$hash$great,
    $less$: Infix_$less$dollar,
    $$great: Infix_$$great,
    $less$at$great: Infix_$less$at$great,
    $less$less$$great$great: Infix_$less$less$dollar$great$great,
    ApplyExtensions: Infix_ApplyExtensions,
    $less$star$great: $less$star$great,
    $less$star: Infix_$less$star,
    $star$great: Infix_$star$great,
    MonadExtensions: Infix_MonadExtensions,
    $great$great$eq: Infix_$great$great$eq,
    $eq$less$less: Infix_$eq$less$less,
    $great$eq$great: Infix_$great$eq$great,
    $less$eq$less: Infix_$less$eq$less,
    $less$pipe$great: Infix_$less$pipe$great
  };
  var map6 = function (fn, a, b, c, d, e, f) {
    return Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$$great, fn, a), b), c), d), e), f);
  };
  var map7 = function (fn, a, b, c, d, e, f, g) {
    return Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$$great, fn, a), b), c), d), e), f), g);
  };
  var mapTuple6 = function (fn, param) {
    return map6(fn, param[0], param[1], param[2], param[3], param[4], param[5]);
  };
  var mapTuple7 = function (fn, param) {
    return map7(fn, param[0], param[1], param[2], param[3], param[4], param[5], param[6]);
  };
  return {
          Functor: Functor,
          map: map$2,
          mapError: mapError,
          BsFunctorExtensions: include.BsFunctorExtensions,
          flipMap: include.flipMap,
          $$void: include.$$void,
          voidRight: include.voidRight,
          voidLeft: include.voidLeft,
          flap: include.flap,
          Alt: Alt,
          alt: alt,
          orElse: include$1.orElse,
          Apply: Apply,
          apply: apply,
          BsApplyExtensions: include$2.BsApplyExtensions,
          applyFirst: include$2.applyFirst,
          applySecond: include$2.applySecond,
          map2: include$2.map2,
          map3: include$2.map3,
          map4: include$2.map4,
          map5: include$2.map5,
          tuple2: include$2.tuple2,
          tuple3: include$2.tuple3,
          tuple4: include$2.tuple4,
          tuple5: include$2.tuple5,
          mapTuple2: include$2.mapTuple2,
          mapTuple3: include$2.mapTuple3,
          mapTuple4: include$2.mapTuple4,
          mapTuple5: include$2.mapTuple5,
          Applicative: Applicative,
          pure: pure,
          BsApplicativeExtensions: include$3.BsApplicativeExtensions,
          liftA1: include$3.liftA1,
          all: include$3.all,
          Semialign: Semialign,
          Monad: Monad,
          bind: flat_map,
          BsMonadExtensions: include$4.BsMonadExtensions,
          flatMap: include$4.flatMap,
          flatten: include$4.flatten,
          composeKleisli: include$4.composeKleisli,
          flipComposeKleisli: include$4.flipComposeKleisli,
          liftM1: include$4.liftM1,
          when_: include$4.when_,
          unless: include$4.unless,
          MonadThrow: MonadThrow,
          throwError: pureRight,
          MonadError: MonadError,
          catchError: catchError$1,
          Infix: Infix,
          map6: map6,
          map7: map7,
          mapTuple6: mapTuple6,
          mapTuple7: mapTuple7
        };
}

function map$2(aToB, ioA) {
  return map$1(undefined, undefined, undefined, aToB, ioA);
}

var Functor = {
  map: map$2
};

var include$1 = Relude_Extensions_Functor.FunctorExtensions(Functor);

var Alt = {
  map: map$2,
  alt: alt
};

var include$2 = Relude_Extensions_Alt.AltExtensions(Alt);

var Apply = {
  map: map$2,
  apply: apply
};

var include$3 = Relude_Extensions_Apply.ApplyExtensions(Apply);

var Applicative = {
  map: map$2,
  apply: apply,
  pure: pure
};

var include$4 = Relude_Extensions_Applicative.ApplicativeExtensions(Applicative);

var Semialign = {
  map: map$2,
  align: align,
  alignWith: alignWith
};

Relude_Extensions_Semialign.SemialignExtensions(Semialign);

function flat_map(ioAE, aToIOBE) {
  return flatMap$1(undefined, undefined, undefined, aToIOBE, ioAE);
}

var Monad = {
  map: map$2,
  apply: apply,
  pure: pure,
  flat_map: flat_map
};

var include$5 = Relude_Extensions_Monad.MonadExtensions(Monad);

var MonadThrow = {
  map: map$2,
  apply: apply,
  pure: pure,
  flat_map: flat_map,
  throwError: pureRight
};

Relude_Extensions_MonadThrow.MonadThrowExtensions(MonadThrow);

function catchError$1(eToIOAF, ioAE) {
  return catchError(undefined, undefined, undefined, eToIOAF, ioAE);
}

var MonadError = {
  map: map$2,
  apply: apply,
  pure: pure,
  flat_map: flat_map,
  throwError: pureRight,
  catchError: catchError$1
};

Relude_Extensions_MonadError.MonadErrorExtensions(MonadError);

var include$6 = Relude_Extensions_Functor.FunctorInfix(Functor);

var $less$$great = include$6.$less$$great;

var include$7 = Relude_Extensions_Bifunctor.BifunctorInfix(Bifunctor);

var include$8 = Relude_Extensions_Apply.ApplyInfix(Apply);

var $less$star$great = include$8.$less$star$great;

var include$9 = Relude_Extensions_Monad.MonadInfix(Monad);

var include$10 = Relude_Extensions_Alt.AltInfix(Alt);

var Infix_FunctorExtensions = include$6.FunctorExtensions;

var Infix_$less$hash$great = include$6.$less$hash$great;

var Infix_$less$dollar = include$6.$less$;

var Infix_$$great = include$6.$$great;

var Infix_$less$at$great = include$6.$less$at$great;

var Infix_$less$less$dollar$great$great = include$7.$less$less$$great$great;

var Infix_ApplyExtensions = include$8.ApplyExtensions;

var Infix_$less$star = include$8.$less$star;

var Infix_$star$great = include$8.$star$great;

var Infix_MonadExtensions = include$9.MonadExtensions;

var Infix_$great$great$eq = include$9.$great$great$eq;

var Infix_$eq$less$less = include$9.$eq$less$less;

var Infix_$great$eq$great = include$9.$great$eq$great;

var Infix_$less$eq$less = include$9.$less$eq$less;

var Infix_$less$pipe$great = include$10.$less$pipe$great;

var Infix = {
  FunctorExtensions: Infix_FunctorExtensions,
  $less$$great: $less$$great,
  $less$hash$great: Infix_$less$hash$great,
  $less$: Infix_$less$dollar,
  $$great: Infix_$$great,
  $less$at$great: Infix_$less$at$great,
  $less$less$$great$great: Infix_$less$less$dollar$great$great,
  ApplyExtensions: Infix_ApplyExtensions,
  $less$star$great: $less$star$great,
  $less$star: Infix_$less$star,
  $star$great: Infix_$star$great,
  MonadExtensions: Infix_MonadExtensions,
  $great$great$eq: Infix_$great$great$eq,
  $eq$less$less: Infix_$eq$less$less,
  $great$eq$great: Infix_$great$eq$great,
  $less$eq$less: Infix_$less$eq$less,
  $less$pipe$great: Infix_$less$pipe$great
};

function map6(fn, a, b, c, d, e, f) {
  return Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$$great, fn, a), b), c), d), e), f);
}

function map7(fn, a, b, c, d, e, f, g) {
  return Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$star$great, Curry._2($less$$great, fn, a), b), c), d), e), f), g);
}

function mapTuple6(fn, param) {
  return map6(fn, param[0], param[1], param[2], param[3], param[4], param[5]);
}

function mapTuple7(fn, param) {
  return map7(fn, param[0], param[1], param[2], param[3], param[4], param[5], param[6]);
}

var WithJsExnError_BsFunctorExtensions = include$1.BsFunctorExtensions;

var WithJsExnError_flipMap = include$1.flipMap;

var WithJsExnError_void = include$1.$$void;

var WithJsExnError_voidRight = include$1.voidRight;

var WithJsExnError_voidLeft = include$1.voidLeft;

var WithJsExnError_flap = include$1.flap;

var WithJsExnError_orElse = include$2.orElse;

var WithJsExnError_BsApplyExtensions = include$3.BsApplyExtensions;

var WithJsExnError_applyFirst = include$3.applyFirst;

var WithJsExnError_applySecond = include$3.applySecond;

var WithJsExnError_map2 = include$3.map2;

var WithJsExnError_map3 = include$3.map3;

var WithJsExnError_map4 = include$3.map4;

var WithJsExnError_map5 = include$3.map5;

var WithJsExnError_tuple2 = include$3.tuple2;

var WithJsExnError_tuple3 = include$3.tuple3;

var WithJsExnError_tuple4 = include$3.tuple4;

var WithJsExnError_tuple5 = include$3.tuple5;

var WithJsExnError_mapTuple2 = include$3.mapTuple2;

var WithJsExnError_mapTuple3 = include$3.mapTuple3;

var WithJsExnError_mapTuple4 = include$3.mapTuple4;

var WithJsExnError_mapTuple5 = include$3.mapTuple5;

var WithJsExnError_BsApplicativeExtensions = include$4.BsApplicativeExtensions;

var WithJsExnError_liftA1 = include$4.liftA1;

var WithJsExnError_all = include$4.all;

var WithJsExnError_BsMonadExtensions = include$5.BsMonadExtensions;

var WithJsExnError_flatMap = include$5.flatMap;

var WithJsExnError_flatten = include$5.flatten;

var WithJsExnError_composeKleisli = include$5.composeKleisli;

var WithJsExnError_flipComposeKleisli = include$5.flipComposeKleisli;

var WithJsExnError_liftM1 = include$5.liftM1;

var WithJsExnError_when_ = include$5.when_;

var WithJsExnError_unless = include$5.unless;

var WithJsExnError = {
  Functor: Functor,
  map: map$2,
  mapError: mapError,
  BsFunctorExtensions: WithJsExnError_BsFunctorExtensions,
  flipMap: WithJsExnError_flipMap,
  $$void: WithJsExnError_void,
  voidRight: WithJsExnError_voidRight,
  voidLeft: WithJsExnError_voidLeft,
  flap: WithJsExnError_flap,
  Alt: Alt,
  alt: alt,
  orElse: WithJsExnError_orElse,
  Apply: Apply,
  apply: apply,
  BsApplyExtensions: WithJsExnError_BsApplyExtensions,
  applyFirst: WithJsExnError_applyFirst,
  applySecond: WithJsExnError_applySecond,
  map2: WithJsExnError_map2,
  map3: WithJsExnError_map3,
  map4: WithJsExnError_map4,
  map5: WithJsExnError_map5,
  tuple2: WithJsExnError_tuple2,
  tuple3: WithJsExnError_tuple3,
  tuple4: WithJsExnError_tuple4,
  tuple5: WithJsExnError_tuple5,
  mapTuple2: WithJsExnError_mapTuple2,
  mapTuple3: WithJsExnError_mapTuple3,
  mapTuple4: WithJsExnError_mapTuple4,
  mapTuple5: WithJsExnError_mapTuple5,
  Applicative: Applicative,
  pure: pure,
  BsApplicativeExtensions: WithJsExnError_BsApplicativeExtensions,
  liftA1: WithJsExnError_liftA1,
  all: WithJsExnError_all,
  Semialign: Semialign,
  Monad: Monad,
  bind: flat_map,
  BsMonadExtensions: WithJsExnError_BsMonadExtensions,
  flatMap: WithJsExnError_flatMap,
  flatten: WithJsExnError_flatten,
  composeKleisli: WithJsExnError_composeKleisli,
  flipComposeKleisli: WithJsExnError_flipComposeKleisli,
  liftM1: WithJsExnError_liftM1,
  when_: WithJsExnError_when_,
  unless: WithJsExnError_unless,
  MonadThrow: MonadThrow,
  throwError: pureRight,
  MonadError: MonadError,
  catchError: catchError$1,
  Infix: Infix,
  map6: map6,
  map7: map7,
  mapTuple6: mapTuple6,
  mapTuple7: mapTuple7
};

function map$3(aToB, ioA) {
  return map$1(undefined, undefined, undefined, aToB, ioA);
}

var Functor$1 = {
  map: map$3
};

var include$11 = Relude_Extensions_Functor.FunctorExtensions(Functor$1);

var Alt$1 = {
  map: map$3,
  alt: alt
};

var include$12 = Relude_Extensions_Alt.AltExtensions(Alt$1);

var Apply$1 = {
  map: map$3,
  apply: apply
};

var include$13 = Relude_Extensions_Apply.ApplyExtensions(Apply$1);

var Applicative$1 = {
  map: map$3,
  apply: apply,
  pure: pure
};

var include$14 = Relude_Extensions_Applicative.ApplicativeExtensions(Applicative$1);

var Semialign$1 = {
  map: map$3,
  align: align,
  alignWith: alignWith
};

Relude_Extensions_Semialign.SemialignExtensions(Semialign$1);

function flat_map$1(ioAE, aToIOBE) {
  return flatMap$1(undefined, undefined, undefined, aToIOBE, ioAE);
}

var Monad$1 = {
  map: map$3,
  apply: apply,
  pure: pure,
  flat_map: flat_map$1
};

var include$15 = Relude_Extensions_Monad.MonadExtensions(Monad$1);

var MonadThrow$1 = {
  map: map$3,
  apply: apply,
  pure: pure,
  flat_map: flat_map$1,
  throwError: pureRight
};

Relude_Extensions_MonadThrow.MonadThrowExtensions(MonadThrow$1);

function catchError$2(eToIOAF, ioAE) {
  return catchError(undefined, undefined, undefined, eToIOAF, ioAE);
}

var MonadError$1 = {
  map: map$3,
  apply: apply,
  pure: pure,
  flat_map: flat_map$1,
  throwError: pureRight,
  catchError: catchError$2
};

Relude_Extensions_MonadError.MonadErrorExtensions(MonadError$1);

var include$16 = Relude_Extensions_Functor.FunctorInfix(Functor$1);

var $less$$great$1 = include$16.$less$$great;

var include$17 = Relude_Extensions_Bifunctor.BifunctorInfix(Bifunctor);

var include$18 = Relude_Extensions_Apply.ApplyInfix(Apply$1);

var $less$star$great$1 = include$18.$less$star$great;

var include$19 = Relude_Extensions_Monad.MonadInfix(Monad$1);

var include$20 = Relude_Extensions_Alt.AltInfix(Alt$1);

var Infix_FunctorExtensions$1 = include$16.FunctorExtensions;

var Infix_$less$hash$great$1 = include$16.$less$hash$great;

var Infix_$less$dollar$1 = include$16.$less$;

var Infix_$$great$1 = include$16.$$great;

var Infix_$less$at$great$1 = include$16.$less$at$great;

var Infix_$less$less$dollar$great$great$1 = include$17.$less$less$$great$great;

var Infix_ApplyExtensions$1 = include$18.ApplyExtensions;

var Infix_$less$star$1 = include$18.$less$star;

var Infix_$star$great$1 = include$18.$star$great;

var Infix_MonadExtensions$1 = include$19.MonadExtensions;

var Infix_$great$great$eq$1 = include$19.$great$great$eq;

var Infix_$eq$less$less$1 = include$19.$eq$less$less;

var Infix_$great$eq$great$1 = include$19.$great$eq$great;

var Infix_$less$eq$less$1 = include$19.$less$eq$less;

var Infix_$less$pipe$great$1 = include$20.$less$pipe$great;

var Infix$1 = {
  FunctorExtensions: Infix_FunctorExtensions$1,
  $less$$great: $less$$great$1,
  $less$hash$great: Infix_$less$hash$great$1,
  $less$: Infix_$less$dollar$1,
  $$great: Infix_$$great$1,
  $less$at$great: Infix_$less$at$great$1,
  $less$less$$great$great: Infix_$less$less$dollar$great$great$1,
  ApplyExtensions: Infix_ApplyExtensions$1,
  $less$star$great: $less$star$great$1,
  $less$star: Infix_$less$star$1,
  $star$great: Infix_$star$great$1,
  MonadExtensions: Infix_MonadExtensions$1,
  $great$great$eq: Infix_$great$great$eq$1,
  $eq$less$less: Infix_$eq$less$less$1,
  $great$eq$great: Infix_$great$eq$great$1,
  $less$eq$less: Infix_$less$eq$less$1,
  $less$pipe$great: Infix_$less$pipe$great$1
};

function map6$1(fn, a, b, c, d, e, f) {
  return Curry._2($less$star$great$1, Curry._2($less$star$great$1, Curry._2($less$star$great$1, Curry._2($less$star$great$1, Curry._2($less$star$great$1, Curry._2($less$$great$1, fn, a), b), c), d), e), f);
}

function map7$1(fn, a, b, c, d, e, f, g) {
  return Curry._2($less$star$great$1, Curry._2($less$star$great$1, Curry._2($less$star$great$1, Curry._2($less$star$great$1, Curry._2($less$star$great$1, Curry._2($less$star$great$1, Curry._2($less$$great$1, fn, a), b), c), d), e), f), g);
}

function mapTuple6$1(fn, param) {
  return map6$1(fn, param[0], param[1], param[2], param[3], param[4], param[5]);
}

function mapTuple7$1(fn, param) {
  return map7$1(fn, param[0], param[1], param[2], param[3], param[4], param[5], param[6]);
}

var WithUnitError_BsFunctorExtensions = include$11.BsFunctorExtensions;

var WithUnitError_flipMap = include$11.flipMap;

var WithUnitError_void = include$11.$$void;

var WithUnitError_voidRight = include$11.voidRight;

var WithUnitError_voidLeft = include$11.voidLeft;

var WithUnitError_flap = include$11.flap;

var WithUnitError_orElse = include$12.orElse;

var WithUnitError_BsApplyExtensions = include$13.BsApplyExtensions;

var WithUnitError_applyFirst = include$13.applyFirst;

var WithUnitError_applySecond = include$13.applySecond;

var WithUnitError_map2 = include$13.map2;

var WithUnitError_map3 = include$13.map3;

var WithUnitError_map4 = include$13.map4;

var WithUnitError_map5 = include$13.map5;

var WithUnitError_tuple2 = include$13.tuple2;

var WithUnitError_tuple3 = include$13.tuple3;

var WithUnitError_tuple4 = include$13.tuple4;

var WithUnitError_tuple5 = include$13.tuple5;

var WithUnitError_mapTuple2 = include$13.mapTuple2;

var WithUnitError_mapTuple3 = include$13.mapTuple3;

var WithUnitError_mapTuple4 = include$13.mapTuple4;

var WithUnitError_mapTuple5 = include$13.mapTuple5;

var WithUnitError_BsApplicativeExtensions = include$14.BsApplicativeExtensions;

var WithUnitError_liftA1 = include$14.liftA1;

var WithUnitError_all = include$14.all;

var WithUnitError_BsMonadExtensions = include$15.BsMonadExtensions;

var WithUnitError_flatMap = include$15.flatMap;

var WithUnitError_flatten = include$15.flatten;

var WithUnitError_composeKleisli = include$15.composeKleisli;

var WithUnitError_flipComposeKleisli = include$15.flipComposeKleisli;

var WithUnitError_liftM1 = include$15.liftM1;

var WithUnitError_when_ = include$15.when_;

var WithUnitError_unless = include$15.unless;

var WithUnitError = {
  Functor: Functor$1,
  map: map$3,
  mapError: mapError,
  BsFunctorExtensions: WithUnitError_BsFunctorExtensions,
  flipMap: WithUnitError_flipMap,
  $$void: WithUnitError_void,
  voidRight: WithUnitError_voidRight,
  voidLeft: WithUnitError_voidLeft,
  flap: WithUnitError_flap,
  Alt: Alt$1,
  alt: alt,
  orElse: WithUnitError_orElse,
  Apply: Apply$1,
  apply: apply,
  BsApplyExtensions: WithUnitError_BsApplyExtensions,
  applyFirst: WithUnitError_applyFirst,
  applySecond: WithUnitError_applySecond,
  map2: WithUnitError_map2,
  map3: WithUnitError_map3,
  map4: WithUnitError_map4,
  map5: WithUnitError_map5,
  tuple2: WithUnitError_tuple2,
  tuple3: WithUnitError_tuple3,
  tuple4: WithUnitError_tuple4,
  tuple5: WithUnitError_tuple5,
  mapTuple2: WithUnitError_mapTuple2,
  mapTuple3: WithUnitError_mapTuple3,
  mapTuple4: WithUnitError_mapTuple4,
  mapTuple5: WithUnitError_mapTuple5,
  Applicative: Applicative$1,
  pure: pure,
  BsApplicativeExtensions: WithUnitError_BsApplicativeExtensions,
  liftA1: WithUnitError_liftA1,
  all: WithUnitError_all,
  Semialign: Semialign$1,
  Monad: Monad$1,
  bind: flat_map$1,
  BsMonadExtensions: WithUnitError_BsMonadExtensions,
  flatMap: WithUnitError_flatMap,
  flatten: WithUnitError_flatten,
  composeKleisli: WithUnitError_composeKleisli,
  flipComposeKleisli: WithUnitError_flipComposeKleisli,
  liftM1: WithUnitError_liftM1,
  when_: WithUnitError_when_,
  unless: WithUnitError_unless,
  MonadThrow: MonadThrow$1,
  throwError: pureRight,
  MonadError: MonadError$1,
  catchError: catchError$2,
  Infix: Infix$1,
  map6: map6$1,
  map7: map7$1,
  mapTuple6: mapTuple6$1,
  mapTuple7: mapTuple7$1
};

function traverse(f, array) {
  var map$4 = function (aToB, ioA) {
    return map$1(undefined, undefined, undefined, aToB, ioA);
  };
  var Functor = {
    map: map$4
  };
  Relude_Extensions_Functor.FunctorExtensions(Functor);
  var Alt = {
    map: map$4,
    alt: alt
  };
  Relude_Extensions_Alt.AltExtensions(Alt);
  var Apply = {
    map: map$4,
    apply: apply
  };
  Relude_Extensions_Apply.ApplyExtensions(Apply);
  var Applicative = {
    map: map$4,
    apply: apply,
    pure: pure
  };
  Relude_Extensions_Applicative.ApplicativeExtensions(Applicative);
  var Semialign = {
    map: map$4,
    align: align,
    alignWith: alignWith
  };
  Relude_Extensions_Semialign.SemialignExtensions(Semialign);
  var flat_map = function (ioAE, aToIOBE) {
    return flatMap$1(undefined, undefined, undefined, aToIOBE, ioAE);
  };
  var Monad = {
    map: map$4,
    apply: apply,
    pure: pure,
    flat_map: flat_map
  };
  Relude_Extensions_Monad.MonadExtensions(Monad);
  var MonadThrow = {
    map: map$4,
    apply: apply,
    pure: pure,
    flat_map: flat_map,
    throwError: pureRight
  };
  Relude_Extensions_MonadThrow.MonadThrowExtensions(MonadThrow);
  var catchError$3 = function (eToIOAF, ioAE) {
    return catchError(undefined, undefined, undefined, eToIOAF, ioAE);
  };
  var MonadError = {
    map: map$4,
    apply: apply,
    pure: pure,
    flat_map: flat_map,
    throwError: pureRight,
    catchError: catchError$3
  };
  Relude_Extensions_MonadError.MonadErrorExtensions(MonadError);
  Relude_Extensions_Functor.FunctorInfix(Functor);
  Relude_Extensions_Bifunctor.BifunctorInfix(Bifunctor);
  Relude_Extensions_Apply.ApplyInfix(Apply);
  Relude_Extensions_Monad.MonadInfix(Monad);
  Relude_Extensions_Alt.AltInfix(Alt);
  var TraverseIO = Curry._1(Array$BsBastet.Traversable, Applicative);
  return Curry._2(TraverseIO.traverse, f, array);
}

function sequence(xs) {
  var map$4 = function (aToB, ioA) {
    return map$1(undefined, undefined, undefined, aToB, ioA);
  };
  var Functor = {
    map: map$4
  };
  Relude_Extensions_Functor.FunctorExtensions(Functor);
  var Alt = {
    map: map$4,
    alt: alt
  };
  Relude_Extensions_Alt.AltExtensions(Alt);
  var Apply = {
    map: map$4,
    apply: apply
  };
  Relude_Extensions_Apply.ApplyExtensions(Apply);
  var Applicative = {
    map: map$4,
    apply: apply,
    pure: pure
  };
  Relude_Extensions_Applicative.ApplicativeExtensions(Applicative);
  var Semialign = {
    map: map$4,
    align: align,
    alignWith: alignWith
  };
  Relude_Extensions_Semialign.SemialignExtensions(Semialign);
  var flat_map = function (ioAE, aToIOBE) {
    return flatMap$1(undefined, undefined, undefined, aToIOBE, ioAE);
  };
  var Monad = {
    map: map$4,
    apply: apply,
    pure: pure,
    flat_map: flat_map
  };
  Relude_Extensions_Monad.MonadExtensions(Monad);
  var MonadThrow = {
    map: map$4,
    apply: apply,
    pure: pure,
    flat_map: flat_map,
    throwError: pureRight
  };
  Relude_Extensions_MonadThrow.MonadThrowExtensions(MonadThrow);
  var catchError$3 = function (eToIOAF, ioAE) {
    return catchError(undefined, undefined, undefined, eToIOAF, ioAE);
  };
  var MonadError = {
    map: map$4,
    apply: apply,
    pure: pure,
    flat_map: flat_map,
    throwError: pureRight,
    catchError: catchError$3
  };
  Relude_Extensions_MonadError.MonadErrorExtensions(MonadError);
  Relude_Extensions_Functor.FunctorInfix(Functor);
  Relude_Extensions_Bifunctor.BifunctorInfix(Bifunctor);
  Relude_Extensions_Apply.ApplyInfix(Apply);
  Relude_Extensions_Monad.MonadInfix(Monad);
  Relude_Extensions_Alt.AltInfix(Alt);
  var TraverseIO = Curry._1(Array$BsBastet.Traversable, Applicative);
  return Curry._1(TraverseIO.sequence, xs);
}

var $$Array = {
  traverse: traverse,
  sequence: sequence
};

function traverse$1(f, list) {
  var map$4 = function (aToB, ioA) {
    return map$1(undefined, undefined, undefined, aToB, ioA);
  };
  var Functor = {
    map: map$4
  };
  Relude_Extensions_Functor.FunctorExtensions(Functor);
  var Alt = {
    map: map$4,
    alt: alt
  };
  Relude_Extensions_Alt.AltExtensions(Alt);
  var Apply = {
    map: map$4,
    apply: apply
  };
  Relude_Extensions_Apply.ApplyExtensions(Apply);
  var Applicative = {
    map: map$4,
    apply: apply,
    pure: pure
  };
  Relude_Extensions_Applicative.ApplicativeExtensions(Applicative);
  var Semialign = {
    map: map$4,
    align: align,
    alignWith: alignWith
  };
  Relude_Extensions_Semialign.SemialignExtensions(Semialign);
  var flat_map = function (ioAE, aToIOBE) {
    return flatMap$1(undefined, undefined, undefined, aToIOBE, ioAE);
  };
  var Monad = {
    map: map$4,
    apply: apply,
    pure: pure,
    flat_map: flat_map
  };
  Relude_Extensions_Monad.MonadExtensions(Monad);
  var MonadThrow = {
    map: map$4,
    apply: apply,
    pure: pure,
    flat_map: flat_map,
    throwError: pureRight
  };
  Relude_Extensions_MonadThrow.MonadThrowExtensions(MonadThrow);
  var catchError$3 = function (eToIOAF, ioAE) {
    return catchError(undefined, undefined, undefined, eToIOAF, ioAE);
  };
  var MonadError = {
    map: map$4,
    apply: apply,
    pure: pure,
    flat_map: flat_map,
    throwError: pureRight,
    catchError: catchError$3
  };
  Relude_Extensions_MonadError.MonadErrorExtensions(MonadError);
  Relude_Extensions_Functor.FunctorInfix(Functor);
  Relude_Extensions_Bifunctor.BifunctorInfix(Bifunctor);
  Relude_Extensions_Apply.ApplyInfix(Apply);
  Relude_Extensions_Monad.MonadInfix(Monad);
  Relude_Extensions_Alt.AltInfix(Alt);
  var TraverseIO = Relude_List_Instances.Traversable(Applicative);
  return Curry._2(TraverseIO.traverse, f, list);
}

function sequence$1(xs) {
  var map$4 = function (aToB, ioA) {
    return map$1(undefined, undefined, undefined, aToB, ioA);
  };
  var Functor = {
    map: map$4
  };
  Relude_Extensions_Functor.FunctorExtensions(Functor);
  var Alt = {
    map: map$4,
    alt: alt
  };
  Relude_Extensions_Alt.AltExtensions(Alt);
  var Apply = {
    map: map$4,
    apply: apply
  };
  Relude_Extensions_Apply.ApplyExtensions(Apply);
  var Applicative = {
    map: map$4,
    apply: apply,
    pure: pure
  };
  Relude_Extensions_Applicative.ApplicativeExtensions(Applicative);
  var Semialign = {
    map: map$4,
    align: align,
    alignWith: alignWith
  };
  Relude_Extensions_Semialign.SemialignExtensions(Semialign);
  var flat_map = function (ioAE, aToIOBE) {
    return flatMap$1(undefined, undefined, undefined, aToIOBE, ioAE);
  };
  var Monad = {
    map: map$4,
    apply: apply,
    pure: pure,
    flat_map: flat_map
  };
  Relude_Extensions_Monad.MonadExtensions(Monad);
  var MonadThrow = {
    map: map$4,
    apply: apply,
    pure: pure,
    flat_map: flat_map,
    throwError: pureRight
  };
  Relude_Extensions_MonadThrow.MonadThrowExtensions(MonadThrow);
  var catchError$3 = function (eToIOAF, ioAE) {
    return catchError(undefined, undefined, undefined, eToIOAF, ioAE);
  };
  var MonadError = {
    map: map$4,
    apply: apply,
    pure: pure,
    flat_map: flat_map,
    throwError: pureRight,
    catchError: catchError$3
  };
  Relude_Extensions_MonadError.MonadErrorExtensions(MonadError);
  Relude_Extensions_Functor.FunctorInfix(Functor);
  Relude_Extensions_Bifunctor.BifunctorInfix(Bifunctor);
  Relude_Extensions_Apply.ApplyInfix(Apply);
  Relude_Extensions_Monad.MonadInfix(Monad);
  Relude_Extensions_Alt.AltInfix(Alt);
  var TraverseIO = Relude_List_Instances.Traversable(Applicative);
  return Curry._1(TraverseIO.sequence, xs);
}

var List = {
  traverse: traverse$1,
  sequence: sequence$1
};

function unsafeRunIoAndWriterAsync(handleResult, handleLog, writerT) {
  return Relude_IO.unsafeRunAsync((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great((function (param) {
                                            return Relude_Result.fold((function (param) {
                                                          var match = param[0];
                                                          return [
                                                                  {
                                                                    TAG: /* Error */1,
                                                                    _0: match[0]
                                                                  },
                                                                  param[1],
                                                                  match[1],
                                                                  match[2]
                                                                ];
                                                        }), (function (param) {
                                                          var match = param[0];
                                                          return [
                                                                  {
                                                                    TAG: /* Ok */0,
                                                                    _0: match[0]
                                                                  },
                                                                  param[1],
                                                                  match[1],
                                                                  match[2]
                                                                ];
                                                        }), param);
                                          }), (function (param) {
                                            var result = param[0];
                                            var tmp;
                                            tmp = result.TAG === /* Ok */0 ? Logger.Data.message("Succeeded") : Logger.Data.message("FAILED");
                                            return [
                                                    Curry._1(handleResult, result),
                                                    Relude_IO.unsafeRunAsync((function (param) {
                                                            return Relude_Result.fold((function (param) {
                                                                          
                                                                        }), (function (param) {
                                                                          
                                                                        }), param);
                                                          }), Curry._1(handleLog, prependLogEntry(undefined, "Execution Summary", param[3], param[2], tmp, param[1])))
                                                  ];
                                          }), param);
                            }), (function (param) {
                              
                            }), param);
              }), Curry._1(runWriterT, flatMap$1(undefined, undefined, undefined, (function (startTimestamp) {
                        return catchError(undefined, undefined, undefined, (function (e) {
                                      return flatMap$1(undefined, undefined, undefined, (function (endTimestamp) {
                                                    return Curry._1(pureRight, [
                                                                e,
                                                                startTimestamp,
                                                                endTimestamp
                                                              ]);
                                                  }), suspend(function (param) {
                                                      return new Date();
                                                    }));
                                    }), flatMap$1(undefined, undefined, undefined, (function (a) {
                                          return map$1(undefined, undefined, undefined, (function (endTimestamp) {
                                                        return [
                                                                a,
                                                                startTimestamp,
                                                                endTimestamp
                                                              ];
                                                      }), suspend(function (param) {
                                                          return new Date();
                                                        }));
                                        }), writerT));
                      }), suspend(function (param) {
                          return new Date();
                        }))));
}

function unsafeRunHandledIoAndWriterAsync(handleLog, io) {
  return unsafeRunIoAndWriterAsync((function (param) {
                return Relude_Result.fold((function (param) {
                              
                            }), (function (param) {
                              
                            }), param);
              }), handleLog, io);
}

function fromPromise(promiseErrorToError, runPromise) {
  return /* BiwriterT */{
          _0: Relude_IO.async(function (onDone) {
                Curry._1(runPromise, undefined).then(function (a) {
                        return Promise.resolve(Curry._1(onDone, {
                                        TAG: /* Ok */0,
                                        _0: [
                                          a,
                                          Log.Monoid.empty
                                        ]
                                      }));
                      }).catch(function (e) {
                      return Promise.resolve(Curry._1(onDone, {
                                      TAG: /* Error */1,
                                      _0: [
                                        Curry._1(promiseErrorToError, e),
                                        Log.Monoid.empty
                                      ]
                                    }));
                    });
                
              })
        };
}

function fromPromiseWithJsExn(lazyPromise) {
  return fromPromise((function (prim) {
                return prim;
              }), lazyPromise);
}

function toPromise(logHandler, io) {
  return new Promise((function (resolve, reject) {
                return unsafeRunIoAndWriterAsync((function (v) {
                              if (v.TAG === /* Ok */0) {
                                return resolve(v._0);
                              } else {
                                return reject(v._0);
                              }
                            }), logHandler, io);
              }));
}

function fromOption(getError, option) {
  return Relude_Option.foldLazy((function (param) {
                return Curry._1(pureRight, Curry._1(getError, undefined));
              }), pure, option);
}

function fromResult(res) {
  return Relude_Result.fold(pureRight, pure, res);
}

function getRetryDelayed(retryCount, io) {
  var millis = Math.imul(170, Relude_Float.floorAsInt(Math.exp(Relude_Int.toFloat(retryCount))));
  return flatMap$1(undefined, undefined, undefined, (function (param) {
                return io;
              }), Curry._1(fromBimonad, Relude_IO.delay(millis)));
}

function retry(maximumRetriesOpt, retryCountOpt, io) {
  var maximumRetries = maximumRetriesOpt !== undefined ? maximumRetriesOpt : 5;
  var retryCount = retryCountOpt !== undefined ? retryCountOpt : 0;
  return catchError(undefined, undefined, undefined, (function (err) {
                if (Curry._2(Relude_Int.greaterThanOrEq, retryCount, maximumRetries)) {
                  return Curry._1(pureRight, err);
                } else {
                  return retry(maximumRetries, retryCount + 1 | 0, getRetryDelayed(retryCount, io));
                }
              }), io);
}

function retry$1(maximumRetries, io) {
  return retry(maximumRetries, undefined, io);
}

var make = include.make;

var execWriterT = include.execWriterT;

var tell = include.tell;

var listen = include.listen;

var listens = include.listens;

var pass = include.pass;

var censor = include.censor;

var bimapWriterT = include.bimapWriterT;

var Biapply = include.Biapply;

var applyLeft = include.applyLeft;

var applyLeftWithAppendLog = include.applyLeftWithAppendLog;

var applyRight = include.applyRight;

var applyRightWithAppendLog = include.applyRightWithAppendLog;

var applyWithAppendLog = include.applyWithAppendLog;

var Biapplicative = include.Biapplicative;

var pureLeft = include.pureLeft;

var pureRightWithLog = include.pureRightWithLog;

var pureLeftWithLog = include.pureLeftWithLog;

var Bimonad = include.Bimonad;

var flatMapLeft = include.flatMapLeft;

var flatMapLeftWithAppendLog = include.flatMapLeftWithAppendLog;

var flatMapRightWithAppendLog = include.flatMapRightWithAppendLog;

var flatMapWithAppendLog = include.flatMapWithAppendLog;

var fromIO = fromBimonad;

var $$throw = pureRight;

var withDelay = withDelayAfter;

var mapLeft$1 = map$1;

exports.prependLogEntry = prependLogEntry;
exports.Biwriter = Biwriter$1;
exports.Log = Log;
exports.make = make;
exports.fromBimonad = fromBimonad;
exports.runWriterT = runWriterT;
exports.execWriterT = execWriterT;
exports.tell = tell;
exports.listen = listen;
exports.listens = listens;
exports.pass = pass;
exports.censor = censor;
exports.Bifunctor = Bifunctor;
exports.bimapWriterT = bimapWriterT;
exports.bimapWithAppendLog = bimapWithAppendLog;
exports.mapLeftWithAppendLog = mapLeftWithAppendLog;
exports.mapRight = mapRight;
exports.mapRightWithAppendLog = mapRightWithAppendLog;
exports.mapWithAppendLog = mapWithAppendLog;
exports.Biapply = Biapply;
exports.applyLeft = applyLeft;
exports.applyLeftWithAppendLog = applyLeftWithAppendLog;
exports.applyRight = applyRight;
exports.applyRightWithAppendLog = applyRightWithAppendLog;
exports.apply = apply;
exports.applyWithAppendLog = applyWithAppendLog;
exports.Biapplicative = Biapplicative;
exports.pureLeft = pureLeft;
exports.pureRight = pureRight;
exports.pureRightWithLog = pureRightWithLog;
exports.pure = pure;
exports.pureLeftWithLog = pureLeftWithLog;
exports.Bimonad = Bimonad;
exports.flatMapLeft = flatMapLeft;
exports.flatMapLeftWithAppendLog = flatMapLeftWithAppendLog;
exports.flatMapRight = flatMapRight;
exports.flatMapRightWithAppendLog = flatMapRightWithAppendLog;
exports.flatMapWithAppendLog = flatMapWithAppendLog;
exports.fromIO = fromIO;
exports.toIO = toIO;
exports.tap = tap;
exports.tapError = tapError;
exports.bitap = bitap;
exports.$$throw = $$throw;
exports.suspend = suspend;
exports.suspendIO = suspendIO;
exports.summonError = summonError;
exports.unsummonError = unsummonError;
exports.biflatMap = biflatMap;
exports.triesJs = triesJs;
exports.delay = delay;
exports.withDelayAfter = withDelayAfter;
exports.withDelay = withDelay;
exports.withDelayBefore = withDelayBefore;
exports.getTimestamp = getTimestamp;
exports.timeIO = timeIO;
exports.addContext = addContext;
exports.mapWithLog = mapWithLog;
exports.mapWithLogMessage = mapWithLogMessage;
exports.map = map$1;
exports.mapLeft = mapLeft$1;
exports.log = log;
exports.logMessage = logMessage;
exports.mapErrorWithLog = mapErrorWithLog;
exports.mapErrorWithLogMessage = mapErrorWithLogMessage;
exports.mapErrorWithLogExn = mapErrorWithLogExn;
exports.mapError = mapError;
exports.logError = logError;
exports.logExn = logExn;
exports.bimapWithLog = bimapWithLog;
exports.bimapWithLogMessage = bimapWithLogMessage;
exports.bimap = bimap$1;
exports.bilog = bilog;
exports.bilogWithMessage = bilogWithMessage;
exports.flatMapWithLog = flatMapWithLog;
exports.flatMapWithLogMessage = flatMapWithLogMessage;
exports.flatMap = flatMap$1;
exports.bind = bind;
exports.catchErrorWithLog = catchErrorWithLog;
exports.catchErrorWithLogMessage = catchErrorWithLogMessage;
exports.catchErrorWithLogExn = catchErrorWithLogExn;
exports.catchError = catchError;
exports.alt = alt;
exports.align = align;
exports.alignWith = alignWith;
exports.WithError = WithError;
exports.WithJsExnError = WithJsExnError;
exports.WithUnitError = WithUnitError;
exports.$$Array = $$Array;
exports.List = List;
exports.unsafeRunIoAndWriterAsync = unsafeRunIoAndWriterAsync;
exports.unsafeRunHandledIoAndWriterAsync = unsafeRunHandledIoAndWriterAsync;
exports.fromPromise = fromPromise;
exports.fromPromiseWithJsExn = fromPromiseWithJsExn;
exports.toPromise = toPromise;
exports.fromOption = fromOption;
exports.fromResult = fromResult;
exports.retry = retry$1;
/* include Not a pure module */
